import ViewApp from './App';
new ViewApp().start();